export function createExchangeRateService(apiClient) {
  const cachedRates = {};
  let lastFetchTime = 0;

  return async function getExchangeRate(currency) {
    const now = Date.now();

    // Return cached rate if < 5 minutes old
    if (cachedRates[currency] && now - lastFetchTime < 1200000) {
      return cachedRates[currency];
    }
    try {
      const { data } = await apiClient.get(`wallet/exchange-rate/${currency}`);
      cachedRates[currency] = data.rate;
      lastFetchTime = now;
      return data.rate;
    } catch {
      return cachedRates[currency] || 1; // Fallback to cached or 1
    }
  };
}
